import axios from 'axios'

/**
 * 用户研究画像 API
 */

/** 检查用户画像完成状态 */
export const checkResearchProfileStatus = () =>
  axios.get('/api/user/profile/research/status')

/** 获取问卷 Schema 定义 */
export const getResearchProfileSchema = () =>
  axios.get('/api/user/profile/research/schema')

// 保存成功后通知当前工作台刷新提示词快照；失败时保持原展示。
function notifyPreferenceSaved(response) {
  if (response.data?.code === 200) window.dispatchEvent(new Event('gutdb-research-preferences-changed'))
  return response
}

/** 保存用户画像 */
export const saveResearchProfile = (data) =>
  axios.post('/api/user/profile/research', data).then(notifyPreferenceSaved)

/** 获取用户画像 */
export const getResearchProfile = () =>
  axios.get('/api/user/profile/research')

/** 更新用户画像 */
export const updateResearchProfile = (data) =>
  axios.put('/api/user/profile/research', data).then(notifyPreferenceSaved)
